import { LoadingModal } from "@mixitone/components";
import { Account, ClubDocument } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import { withStateToggle } from "@mixitone/util";
import AppModal from "components/common/AppModal";
import { PdfViewer, useSizePdfInModal } from "components/Forms/PdfUpload";
import MixitoneController from "controllers/MixitoneController";
import { injectModal } from "lib/injectParams";

interface State {
  document: ClubDocument;
  loading: boolean;
}

interface Props {
  clubId: string;
  documentId: string;
}

class ShowDocumentController extends MixitoneController<State, Props> {
  get initialState(): State {
    return {
      document: new ClubDocument({}),
      loading: true,
    };
  }

  async initialize(props: Props) {
    await this.loadDocument(props.documentId);
  }

  @withStateToggle("loading")
  async loadDocument(documentId: string) {
    const document = await ClubDocument.query().find(documentId);
    if (!document) {
      throw new Error("Document not found");
    }
    this.state.document = document;
  }
}

const ShowDocument = () => {
  const controller = ShowDocumentController.use();
  const { document, loading } = controller.state;
  const { pageHeight, handleLoad, pdfRef, modalRef } = useSizePdfInModal();

  if (!Account.current?.hasFeature("member_players")) {
    return (
      <AppModal title="Access Denied" ref={modalRef}>
        <div className="p-4 text-center text-gray-500">
          To access documents, please{" "}
          <a href="/settings/account/billing" className="text-blue-500 hover:underline">
            upgrade to a Pro account
          </a>
          .
        </div>
      </AppModal>
    );
  }
  if (loading) return <LoadingModal title="Loading Document..." />;

  return (
    <AppModal title={document.title} ref={modalRef}>
      <PdfViewer
        documentId={document.document_id!}
        fileStorage={document.file_storage}
        clubId={document.club_id}
        clubDocumentId={document.id}
        ref={pdfRef}
        onLoad={handleLoad}
        pageHeight={pageHeight}
      />
    </AppModal>
  );
};

export default injectModal(ShowDocumentController.scope(ApplicationView(ShowDocument)));
